import React from 'react'
import css from './index.m.css'
export default (props)=>{
  const {isRequired,versionTitle} = props
  return (
    <div className={css['version-label']}>
      {isRequired && <span style={{ color:"#F36F64"}}>*</span>}
      {versionTitle}
    </div>
  )
}
